import {Link} from 'gatsby'
import React, { Component } from 'react'
import { cn, getPageUrl } from '../lib/helpers'
import Offer from '../components/offer'

import * as styles from './dynamic-zone-component.module.css'

function DynamicZoneComponent ({component}) {
  
  if (component.__typename == "STRAPI_ComponentContentListTopN"){
    return (
        <div key={component.id}>
          {component.page && 
          <Link to={"/"+component.page.slug} className={styles.subheading}>
              <h2>{component.title}</h2>
          </Link>
          }
          { !component.page && 
          <h2>{component.title}</h2>
          }
            <p>{component.description}</p>
          { component.offers && 
            component.offers.map(offer => (
              <span key={offer.id}><Offer offer={offer}></Offer></span>
            ))
          }
        </div>
      )
  }
  if (component.__typename == "STRAPI_ComponentContentEmbeddedHtml"){
    return (
        <div dangerouslySetInnerHTML={{__html: component.raw_html }} />
    )
  }
  return (
    <div>
        <h2>{component.__typename}</h2>
    </div>
  )
}

DynamicZoneComponent.defaultProps = {
    props: {},
  }

export default DynamicZoneComponent
